type ConsoleEnv = { environment?: string; production?: boolean; enableDebug?: boolean };

const SILENT = ['log', 'info', 'debug', 'trace', 'table', 'dir', 'dirxml', 'group', 'groupCollapsed', 'time', 'timeLog', 'count'];

const REDACTIONS: [RegExp, string][] = [
  [/eyJ[\w-]+\.[\w-]+\.[\w-]+/g, '[token]'],
  [/Bearer\s+\S+/gi, 'Bearer [token]'],
  [/AIza[\w-]{30,}/g, '[key]'],
  [/\b(key|lc|sk)_(live|test)_\w+/g, '[key]'],
  [/gs:\/\/\S+/g, '[file]'],
  [/https?:\/\/\S+/g, '[url]'],
  [/\b[\w.-]+\.(appspot\.com|firebasestorage\.app|firebaseapp\.com|run\.app|cloudfunctions\.net)\b/g, '[host]'],
  [/\bmona-[\w-]+/g, '[project]'],
  [/\b(accounts|customers|users|companies|partnerTenants|branding|applicants)\/\S+/g, '[path]'],
  [/[\w.+-]+@[\w-]+(\.[\w-]+)+/g, '[email]'],
  [/\b(?=[A-Za-z0-9]*\d)[A-Za-z0-9]{20,}\b/g, '[id]'],
  [/\b(coolstore|coolStorage|customerStorage|secondApp|perfectstore|videoStore)\b/gi, 'storage']
];

export function redact(text: string): string {
  return REDACTIONS.reduce((out, [pattern, replacement]) => out.replace(pattern, replacement), text);
}

export function describeArg(arg: any): string {
  if (typeof arg === 'string') return arg;
  if (typeof arg === 'number' || typeof arg === 'boolean') return String(arg);
  if (arg && typeof arg === 'object') {
    const code = typeof arg.code === 'string' || typeof arg.code === 'number' ? String(arg.code) : '';
    const message = typeof arg.message === 'string' ? arg.message : '';
    return [code, message].filter(Boolean).join(': ');
  }
  return '';
}

export function consoleMode(env: ConsoleEnv): 'production' | 'sandbox' | 'full' {
  if (env.enableDebug) return 'full';
  if (env.environment === 'test') return 'sandbox';
  return env.production ? 'production' : 'full';
}

export function applyConsolePolicy(env: ConsoleEnv, target: any = window.console): void {
  const mode = consoleMode(env);
  if (mode === 'full') return;
  const error = target.error.bind(target);
  const warn = target.warn.bind(target);
  const noop = () => { };
  SILENT.forEach(method => { if (typeof target[method] === 'function') target[method] = noop; });
  if (mode === 'production') {
    target.warn = noop;
    target.error = () => error('MONA: An error occurred.');
    return;
  }
  const developerMessage = (args: any[]) => `MONA: ${redact(args.map(describeArg).filter(Boolean).join(' ')) || 'An error occurred.'}`;
  target.warn = (...args: any[]) => warn(developerMessage(args));
  target.error = (...args: any[]) => error(developerMessage(args));
}
